import { Checkbox, CheckboxProps } from "@mui/material";
import { ReactComponent as CheckboxCheckedIcon } from "../assets/Icons/checkbox-checked.svg";
import { ReactComponent as CheckboxIcon } from "../assets/Icons/checkbox.svg";

const GKCheckbox = (
  props: CheckboxProps & {
    disableLeftPadding?: boolean;
    padding?: any;
    disableRightPadding?: boolean;
  },
) => {
  const {
    disableLeftPadding,
    padding,
    disabled,
    disableRightPadding,
    ...rest
  } = props;

  return (
    <Checkbox
      {...rest}
      icon={<CheckboxIcon />}
      disabled={disabled}
      checkedIcon={
        <CheckboxCheckedIcon
          color={disabled ? "var(--grey-500)" : "var(--primary-900)"}
        />
      }
      sx={{
        ...props.sx,
        paddingLeft: disableLeftPadding ? 0 : padding,
        paddingRight: disableRightPadding ? 0 : padding,
        "&.Mui-disabled svg": {
          color: "var(--primary-300)",
        },
      }}
    />
  );
};

export default GKCheckbox;
